export default __webpack_public_path__ + "static/media/24.a4f61815.jpg";